import React from "react";
import Text from "./Text";
import { fontSizes } from "../constants/constants";
import dynamicfunction from "../utils/dynamicfunction";
import ViewReverse from "./ViewReverse";

const NotificationListItem = ({ title, description, isRead, time }) => {
  const { TextWeight } = dynamicfunction();

  return (
    <div
      className={`px-5 py-4 border-b border-b-grey cursor-pointer ${
        isRead ? "bg-white" : "bg-grey/30"
      } hover:bg-light-blue/20`}
    >
        <ViewReverse className={'justify-between'}>
      <Text
        text={title}
        size={fontSizes.h14}
        className={`${isRead ? "text-opacity-50" : "text-opacity-100"}`}
      />
      <Text
        text={time}
        size={fontSizes.h14}
        color="text-dark-grey/50"
      />
        </ViewReverse>
      <Text
        text={description}
        weight={TextWeight.light}
        className={"text-opacity-50"}
      />
    </div>
  );
};

export default NotificationListItem;
